import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import HoverMessage from 'common/components/HoverMessage';
import { referenceTracker } from 'v3/quantConfig/reference/referenceTracker';
import { REFERENCE_LIST } from 'v2/common/constants';
import { pipeConfigPropTypes } from 'common/propTypes';

const propTypes = {
  onDeletePipeConfig: PropTypes.func,
  onEditPipeConfig: PropTypes.func,
  isHiddenSignal: PropTypes.bool,
  currentPipeConfigIndex: PropTypes.number.isRequired,
  pipeConfig: pipeConfigPropTypes.isRequired,
};
const defaultProps = {
  onDeletePipeConfig: () => {},
  onEditPipeConfig: () => {},
  isHiddenSignal: false
};

const EditOrDeleteButton = ({
  onDeletePipeConfig, onEditPipeConfig, isHiddenSignal, currentPipeConfigIndex, pipeConfig
}) => {
  const renderPipeConfigEditButton = useMemo(() => {
    return (
      <button
        type="button"
        disabled={isHiddenSignal}
        className="btn btn-secondary py-1 px-2 d-flex align-items-center gap-0"
        onClick={() => {
          if (!isHiddenSignal) onEditPipeConfig();
        }}
      >
        <i className="fa-light fa-pen edit-icon me-2"></i>
        Edit
      </button>
    );
  }, [isHiddenSignal, onEditPipeConfig]);
  
  const handleDeletePipeConfig = useCallback(() => {
      const pipeEntity = {
        type: REFERENCE_LIST.pipe,
        index: currentPipeConfigIndex,
        details: pipeConfig
      };
      referenceTracker.performDeleteOrShowWarning( pipeEntity, () => onDeletePipeConfig());
  }, [onDeletePipeConfig]);

  return (
    <div className="d-flex align-items-center actions-btn">
      <HoverMessage
        message="Delete"
        popClassName="d-sm-none d-md-block custom-popover"
      >
        <button
          type="button"
          className="delete-button btn btn-outline-secondary me-2"
          onClick={handleDeletePipeConfig}
        >
         <i className="fa-regular fa-trash-can"></i>
        </button>
      </HoverMessage>
      {isHiddenSignal ? (
        <HoverMessage message="This action has been disabled by the Author">
          {renderPipeConfigEditButton}
        </HoverMessage>
      ) : (
        renderPipeConfigEditButton
      )}
    </div>
  );
};

EditOrDeleteButton.propTypes = propTypes;
EditOrDeleteButton.defaultProps = defaultProps;

export default memo(EditOrDeleteButton);
